import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { Address } from '../interface/address';

/**
 * @description this message service
 * will be used to communicate between
 * components
 * @date 2018-07-20
 * @export
 * @class EnrollmentMessageService
 */
@Injectable()
export class EnrollmentMessageService {

    private submitGuestForm: Subject<boolean> = new Subject<boolean>();
    private clearGuestForm: Subject<boolean> = new Subject<boolean>();
    private submitPersonalInfoForm: Subject<boolean> = new Subject<boolean>();
    private clearPersonalInfoForm: Subject<boolean> = new Subject<boolean>();
    private suggestSponsorPreference: Subject<Address> = new Subject<Address>();
    private storeInfo: Subject<StoreConfig> = new Subject<StoreConfig>();
    private isEmailAlreadyExists: Subject<boolean> = new Subject<boolean>();
    private isSponsorInfoSelected: Subject<boolean> = new Subject<boolean>();
    private participatingCountryInfo: Subject<number> = new Subject<number>();


    getSubmitGuestForm(): Observable<boolean> {
        return this.submitGuestForm.asObservable();
    }

    setSubmitGuestForm(isSubmit: boolean): void {
        this.submitGuestForm.next(isSubmit);
    }

    getClearGuestForm(): Observable<boolean> {
        return this.clearGuestForm.asObservable();
    }

    setClearGuestForm(): void {
        this.clearGuestForm.next();
    }

    getSubmitPersonalInfoForm(): Observable<boolean> {
        return this.submitPersonalInfoForm.asObservable();
    }

    setSubmitPersonalInfoForm(isSubmit: boolean): void {
        this.submitPersonalInfoForm.next(isSubmit);
    }

    getClearPersonalInfoForm(): Observable<boolean> {
        return this.clearPersonalInfoForm.asObservable();
    }

    setClearPersonalInfoForm(): void {
        this.clearPersonalInfoForm.next();
    }

    getSponsorPreference(): Observable<Address> {
        return this.suggestSponsorPreference.asObservable();
    }

    setSponsorPreference(liveFormAddress: Address): void {
        this.suggestSponsorPreference.next(liveFormAddress);
    }

    getStoreInfo(): Observable<StoreConfig> {
        return this.storeInfo.asObservable();
    }

    setStoreInfo(storeInfo: StoreConfig): void {
        this.storeInfo.next(storeInfo);
    }

    getIsEmailAlreadyExists(): Observable<boolean> {
        return this.isEmailAlreadyExists.asObservable();
    }

    setIsEmailAlreadyExists(isEmailExists: boolean): void {
        this.isEmailAlreadyExists.next(isEmailExists);
    }

    setIsSponsorInfoSelected(isSponsorInfoSelected: boolean): void {
        this.isSponsorInfoSelected.next(isSponsorInfoSelected);
    }

    getIsSponsorInfoSelected(): Observable<boolean> {
        return this.isSponsorInfoSelected.asObservable();
    }

    getParticipatingCountryInfo(): Observable<number> {
        return this.participatingCountryInfo.asObservable();
    }

    setParticipatingCountryInfo(countryID: number): void {
        this.participatingCountryInfo.next(countryID);
    }

}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/enrollment-message.service.ts